//-------------------------------------------------------------------------------------------------- Import
import React from "react";



//-------------------------------------------------------------------------------------------------- Types
type CSSProperties = {
	[key: string]: React.CSSProperties;
};



//-------------------------------------------------------------------------------------------------- StyleSheet
export class StyleSheet {
	static create<Styles extends CSSProperties>(styles: Styles): Styles {
		return styles;
	};
};
